<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">{{ config.data.header }}</span>
      <span class="text-light-color text-base font-normal">#{{ config.data.id }}</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl border-1 border-neutral-base-primary-border border-round-lg flex flex-column gap-spacing-xl table-bg-hover-bg">
  <div class="form-group flex flex-column gap-spacing-xs">
    <label
      class="input-label flex flex-column gap-spacing-default body-medium-medium text-secondary-color"
      for="reasonInput"
      >Reason
      <span class="body-small-medium text-caption-color">{{ config.data.inputPlaceholder }}</span>
    </label>
    <p-autoComplete
      #reasonInput="ngModel"
      #autoCompleteRef
      [(ngModel)]="reason"
      [suggestions]="filteredSuggestions"
      (completeMethod)="filterSuggestions($event, autoCompleteRef)"
      (onFocus)="filterSuggestions($event, autoCompleteRef)"
      [showEmptyMessage]="false"
      appendTo="body"
      required
      inputStyleClass="px-spacing-md pt-spacing-md"
      [style]="{ width: '100%' }"
      [inputStyle]="{ paddingBottom: '72px', height: '100px' }"
      placeholder="Select or enter a reason." />
    @if (reasonInput.dirty && reasonInput.errors && reasonInput.errors["required"]) {
      <small class="input-helper-text label-medium-regular text-danger-color">This field is required.</small>
    }
  </div>
  <div class="warning-messages border-round-md p-spacing-md background-muted-warning-bg flex gap-spacing-xs align-items-center">
    <i class="icon-warning-solid text-xl icon-warning-color"></i>
    <ul class="mb-0 pl-spacing-2xs list-none">
      @for (m of config.data.warningMessages; track $index) {
        <li class="label-large-regular text-warning-color">{{ m }}</li>
      }
    </ul>
  </div>
</div>

<div class="footer pb-spacing-3xl pt-spacing-4xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Cancel"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    [label]="config.data.header"
    [isLoading]="loading"
    [disabled]="loading || !!reasonInput?.invalid || reasonInput.value?.trim().length <= 0"
    [iconStart]="loading ? 'icon-spinner-gap' : ''"
    (btnClick)="confirmAction()"
    sizeClass="p-button-md"
    severity="danger"></app-button>
</div>
